import React, { useEffect, useState } from "react";
import { toast, Toaster } from "sonner";
import Modal from "react-modal";
import { getInvoiceList, updateInvoiceStatus } from "../../services/vendor";
import { dateTimeFormatter } from "../../services/helper";
import VendorInvoiceDetailModal from "../../components/Modals/VendorInvoiceDetailModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InvoiceDetailsModal } from "../admin/modal/InvoiceDetailsModal";
import {
  Modal as AntModal,
  Button,
  DatePicker,
  Input,
  Pagination,
  Space,
  Table,
  Tag,
} from "antd";
import { Eye, X } from "lucide-react";
import dayjs from "dayjs";

const validationSchema = Yup.object().shape({
  transactionId: Yup.string("Enter Transaction Id").required(
    "Please Enter Transaction Id"
  ),
  paymentDate: Yup.string("Select Payment Date").required(
    "Please Select Payment Date"
  ),
  paidAmount: Yup.string("Enter Paid Amount").required(
    "Please Enter Paid Amount"
  ),
});
const initialState = {
  transactionId: "",
  paymentDate: "",
  paidAmount: "",
};

const getStatusColor = (status) => {
  switch (status) {
    case "paid":
      return "success";
    case "initiated":
      return "processing";
    case "pending":
      return "warning";
    case "cancelled":
      return "error";
    default:
      return "default";
  }
};

const VendorInvoices = () => {
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showConfirmBox, setShowConfirmBox] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [updateModal, setUpdateModal] = useState("");

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    onSubmit: async () => {
      const payload = {
        transaction_id: formik?.values?.transactionId,
        payment_date: formik?.values?.paymentDate,
        paid_amount: formik?.values?.paidAmount,
      };
      if (formik?.isValid && formik?.dirty) {
        // const response = await updateInvoiceApi(payload);
        // const { data, status } = response || {};
        // if (status === 200 || status === 201) {
        //   toast.success(data?.message);
        //   formik.handleReset();
        //   getInvoiceListData();
        //   setUpdateModal(false);
        // } else {
        //   toast?.error(data?.message || "Error Updating Invoice")
        // }
        await handleActionButtons("paid", selectedInvoice, payload);
        formik.handleReset();
        setUpdateModal(false);
      }
    },
  });

  useEffect(() => {
    console.log("inside vendor invoices");
    getInvoicesList(listPayload);
  }, []);

  const handleActionButtons = async (action, id, data = null) => {
    if (["cancelled", "initiated"].includes(action.toLowerCase())) {
      const response = await updateInvoiceStatus({
        invoice_id: id,
        status: action,
      });
      if (response?.status === 200) {
        toast.success(response?.data?.message ?? "Status updated successfully");
        getInvoicesList(listPayload);
      } else {
        toast.error("Error getting vendor invoices");
      }
    } else if (action.toLowerCase() === "paid") {
      const response = await updateInvoiceStatus({
        invoice_id: id,
        status: action,
        ...data,
      });
      if (response?.status === 200) {
        toast.success(response?.data?.message ?? "Status updated successfully");
        getInvoicesList(listPayload);
      } else {
        toast.error("Error getting vendor invoices");
      }
    } else {
      toast.error("Unknown action taken");
    }
  };

  // - - - - - N E W - - - - -
  const [invoicesData, setInvoicesData] = useState([]);
  const [listPayload, setListPayload] = useState({
    limit: 10,
    offset: 0,
    vendor_id: null,
    company_id: null,
    bill_month: null,
  });
  const [totalLengthListData, setTotalLengthListData] = useState(0);

  useEffect(() => {
    getInvoicesList(listPayload);
  }, []);

  const getInvoicesList = async ({
    limit = 10,
    offset = 0,
    vendor_id = null,
    company_id = null,
    bill_month = null,
  }) => {
    const payload = {
      limit,
      offset,
      vendor_id,
      company_id,
      search: bill_month,
    };
    const response = await getInvoiceList(payload);
    const { data, page_number } = response?.data || {};
    if (response?.status === 200) {
      debugger;
      setInvoicesData(response?.data?.data);
      setTotalLengthListData(response?.data?.invoices?.total);
    } else {
      toast.error("Error getting vendor invoices");
    }
  };

  const paginationHandler = (page, limit) => {
    getInvoicesList({
      ...listPayload,
      limit,
      offset: page * limit - limit,
    });
    setListPayload((pre) => ({
      ...pre,
      limit,
      offset: page * limit - limit,
    }));
  };

  // NEW
  const [selectedInvoiceNew, setSelectedInvoiceNew] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleViewInvoice = (invoice) => {
    setSelectedInvoiceNew(invoice);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedInvoiceNew(null);
  };

  const Newcolumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      key: "invoice_number",
      width: 140,
      render: (text) => (
        <span className="font-medium text-gray-900">{text}</span>
      ),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      width: 120,
      render: (date) => dateTimeFormatter(date, false) || "N/A",
    },
    {
      title: "Bill Month",
      dataIndex: "bill_month",
      key: "bill_month",
      width: 100,
    },
    {
      title: "Company Name",
      dataIndex: ["company", "company_name"],
      key: "company_name",
      render: (name) => name || "N/A",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Requestor Email",
      dataIndex: "requester_email",
      key: "requester_email",
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status) => (
        <Tag color={getStatusColor(status)} className="font-medium">
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      fixed: "right",
      render: (_, record) => (
        <Space size="small" className="flex-nowrap">
          <Button
            type="primary"
            ghost
            size="small"
            icon={<Eye size={14} />}
            onClick={() => handleViewInvoice(record)}
            className="flex items-center justify-center min-w-[60px]"
          >
            View
          </Button>
          {record?.status?.toLowerCase() === "approved" && (
            <Button
              className="ml-2"
              onClick={() => {
                setShowConfirmBox(true);
                setSelectedAction("initiated");
                setSelectedInvoice(record.id);
              }}
            >
              Initiate
            </Button>
          )}

          {record?.status?.toLowerCase() === "initiated" && (
            <Button
              className="ml-2"
              onClick={() => {
                setUpdateModal(true);
                setSelectedAction("paid");
                setSelectedInvoice(record.id);
              }}
            >
              Paid
            </Button>
          )}

          {["pending", "approved", "initiated"].includes(
            record?.status?.toLowerCase()
          ) && (
            <Button
              danger
              className="ml-2"
              onClick={() => {
                setShowConfirmBox(true);
                setSelectedAction("cancelled");
                setSelectedInvoice(record.id);
              }}
            >
              Cancel
            </Button>
          )}
          {record.status === "PENDING" && (
            <Button
              type="primary"
              ghost
              danger
              size="small"
              icon={<X size={14} />}
              className="flex items-center justify-center min-w-[70px]"
            >
              Cancel
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="min-h-screen">
        <div
          style={{
            marginBottom: 24,
            color: "#0471a3",
            fontSize: "1.5rem",
            fontWeight: 600,
          }}
        >
          Vendor Invoices
        </div>
        <div className="max-w-7xl mx-auto mt-6">
          {/* Invoice Table */}
          {/* <Card className="shadow-sm"> */}
          <div className="bg-white pb-2">
            <Table
              columns={Newcolumns}
              dataSource={invoicesData}
              pagination={false}
              bordered
              scroll={{ x: 1400 }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: 16,
                marginBottom: 16,
                marginRight: 10,
                textAlign: "right",
              }}
            >
              <Pagination
                showQuickJumper
                total={totalLengthListData}
                showSizeChanger={true}
                pageSizeOptions={["10", "20", "50", "100"]}
                onChange={paginationHandler}
              />
            </div>
          </div>
          {/* </Card> */}
        </div>
      </div>

      {/* - - - - - M O D A L - - - - - */}
      {/* V I E W */}
      <InvoiceDetailsModal
        visible={isModalVisible}
        onClose={handleCloseModal}
        invoice={selectedInvoiceNew}
      />
      {/* P A I D */}
      <AntModal
        open={updateModal}
        onCancel={() => setUpdateModal(false)}
        footer={null}
        centered
        width={950}
      >
        <form onSubmit={formik.handleSubmit} className="p-3 mt-2">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-5">
            {/* Transaction ID */}
            <div className="mb-4">
              <label className="block text-xs font-bold text-gray-700 mb-1 uppercase">
                Transaction Id
              </label>
              <Input
                placeholder="Enter Transaction Id"
                value={formik.values.transactionId}
                onChange={(e) =>
                  formik.setFieldValue("transactionId", e.target.value)
                }
              />
              {formik.errors.transactionId && formik.touched.transactionId && (
                <div className="text-xs text-red-600 mt-1">
                  {formik.errors.transactionId}
                </div>
              )}
            </div>

            {/* Payment Date */}
            <div className="mb-4">
              <label className="block text-xs font-bold text-gray-700 mb-1 uppercase">
                Payment Date
              </label>
              <DatePicker
                className="w-full"
                placeholder="Select Payment Date"
                value={
                  formik.values.paymentDate
                    ? dayjs(formik.values.paymentDate)
                    : null
                }
                onChange={(date) =>
                  formik.setFieldValue(
                    "paymentDate",
                    date?.format("YYYY-MM-DD")
                  )
                }
              />
              {formik.errors.paymentDate && formik.touched.paymentDate && (
                <div className="text-xs text-red-600 mt-1">
                  {formik.errors.paymentDate}
                </div>
              )}
            </div>

            {/* Paid Amount */}
            <div className="mb-4">
              <label className="block text-xs font-bold text-gray-700 mb-1 uppercase">
                Paid Amount
              </label>
              <Input
                // type="number"
                placeholder="Enter Paid Amount"
                value={formik.values.paidAmount}
                onChange={(e) =>
                  formik.setFieldValue("paidAmount", e.target.value)
                }
              />
              {formik.errors.paidAmount && formik.touched.paidAmount && (
                <div className="text-xs text-red-600 mt-1">
                  {formik.errors.paidAmount}
                </div>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="text-center mt-5">
            <Button
              type="primary"
              htmlType="submit"
              className="w-1/2 bg-[#165470] hover:bg-[#143d4f] border-none"
              size="large"
            >
              Update
            </Button>
          </div>
        </form>
      </AntModal>

      {/* CANCEL */}
      <AntModal
        open={showConfirmBox}
        onCancel={() => setShowConfirmBox(false)}
        footer={null}
        centered
      >
        <div style={{ textAlign: "center", paddingTop: 20, paddingBottom: 10 }}>
          <p style={{ fontSize: 16 }}>Are you sure you want to proceed?</p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 10,
              marginTop: 20,
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                handleActionButtons(selectedAction, selectedInvoice);
                setShowConfirmBox(false);
                setSelectedAction("");
                setSelectedInvoice("");
              }}
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setShowConfirmBox(false);
                setSelectedAction("");
              }}
            >
              No
            </Button>
          </div>
        </div>
      </AntModal>
    </>
  );
};

export default VendorInvoices;
